"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValueDifference_1 = require("../../core/model/ValueDifference");

var utils_1 = require("../../core/utils");

var PromotionStateEnum_1 = require("../../promotion/model/PromotionStateEnum");

var StoreSpecificationEnum_1 = require("../../promotion/model/StoreSpecificationEnum");

var WindowStateEnum_1 = require("../../window/model/WindowStateEnum");

var ForecastChangeWindowDTO_1 = require("../model/ForecastChangeWindowDTO");

var WindowChangeType_1 = require("../model/WindowChangeType");

var ForecastChangeWindowDTOConverter_1 = require("./ForecastChangeWindowDTOConverter");
/**
 * @author OPt
 */


var ForecastChangeWindowDTOConverterImpl =
/*#__PURE__*/
function (_ForecastChangeWindow) {
  _inherits(ForecastChangeWindowDTOConverterImpl, _ForecastChangeWindow);

  function ForecastChangeWindowDTOConverterImpl() {
    _classCallCheck(this, ForecastChangeWindowDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastChangeWindowDTOConverterImpl).apply(this, arguments));
  }

  _createClass(ForecastChangeWindowDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ForecastChangeWindowDTO_1.ForecastChangeWindowDTO(ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.promotionCode.valueOfField(source), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.promotionTypeId.valueOf(conversions.toClassReferenceId(source.promotionTypeId)), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.promotionWorkflowState.valueOf(utils_1.Utils.isValueMissing(source.promotionWorkflowState) ? null : conversions.asEnum(source.promotionWorkflowState, PromotionStateEnum_1.PromotionStateEnum)), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.promotionDateFrom.valueOfField(source), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.storeSpecification.valueOf(conversions.asEnum(source.storeSpecification, StoreSpecificationEnum_1.StoreSpecificationEnum)), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.windowId.valueOf(conversions.toClassReferenceId(source.windowId)), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.windowName.valueOfField(source), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.windowTypeId.valueOf(conversions.toClassReferenceId(source.windowTypeId)), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.windowDateFrom.valueOfField(source), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.windowDateTo.valueOfField(source), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.windowWorkflowState.valueOf(utils_1.Utils.isValueMissing(source.promotionWorkflowState) ? null : conversions.asEnum(source.windowWorkflowState, WindowStateEnum_1.WindowStateEnum)), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.validDaysCount.valueOfField(source), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.skuCount.valueOfField(source), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.windowChangeType.valueOf(conversions.asEnum(source.windowChangeType, WindowChangeType_1.WindowChangeType)), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.sales.valueOf(conversions.asObject(source, 'sales', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions))), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.promoVolume.valueOf(conversions.asObject(source, 'promoVolume', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions))), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.gm.valueOf(conversions.asObject(source, 'gm', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions))), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.gmPercentage.valueOf(conversions.asObject(source, 'gmPercentage', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions))), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.proxyBm2.valueOf(conversions.asObject(source, 'proxyBm2', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions))), ForecastChangeWindowDTO_1.ForecastChangeWindowDTO.schema.proxyBm2Percentage.valueOf(conversions.asObject(source, 'proxyBm2Percentage', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions))));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        promotionCode: source.promotionCode,
        promotionTypeId: conversions.toDocumentReferenceId(source.promotionTypeId),
        promotionWorkflowState: utils_1.Utils.isValueMissing(source.promotionWorkflowState) ? null : source.promotionWorkflowState,
        promotionDateFrom: source.promotionDateFrom,
        storeSpecification: source.storeSpecification,
        windowId: conversions.toDocumentReferenceId(source.windowId),
        windowName: source.windowName,
        windowTypeId: conversions.toDocumentReferenceId(source.windowTypeId),
        windowDateFrom: source.windowDateFrom,
        windowDateTo: source.windowDateTo,
        windowWorkflowState: utils_1.Utils.isValueMissing(source.windowWorkflowState) ? null : source.windowWorkflowState,
        validDaysCount: source.validDaysCount,
        skuCount: source.skuCount,
        windowChangeType: source.windowChangeType,
        sales: conversions.asObject(source, 'sales', ValueDifference_1.serializeValueDifferenceBigNumber(conversions)),
        promoVolume: conversions.asObject(source, 'promoVolume', ValueDifference_1.serializeValueDifferenceBigNumber(conversions)),
        gm: conversions.asObject(source, 'gm', ValueDifference_1.serializeValueDifferenceBigNumber(conversions)),
        gmPercentage: conversions.asObject(source, 'gmPercentage', ValueDifference_1.serializeValueDifferenceBigNumber(conversions)),
        proxyBm2: conversions.asObject(source, 'proxyBm2', ValueDifference_1.serializeValueDifferenceBigNumber(conversions)),
        proxyBm2Percentage: conversions.asObject(source, 'proxyBm2Percentage', ValueDifference_1.serializeValueDifferenceBigNumber(conversions))
      });
      return result;
    }
  }]);

  return ForecastChangeWindowDTOConverterImpl;
}(ForecastChangeWindowDTOConverter_1.ForecastChangeWindowDTOConverter);

exports.ForecastChangeWindowDTOConverterImpl = ForecastChangeWindowDTOConverterImpl;